import React from "react";
//#region types
import { WintUtilsWebApi } from "wint-api-client/dist/types";
import { AllTodoListViewProps } from "models/propTypes/todoPropTypes";
import { TodoFormTypes } from "models/formTypes";
//#endregion
//#region components
import { useFilterContext } from "components/common";
import { ToDoListViewInner } from "components/todos";
import { useTodoService } from "serviceHooks";
//#endregion

const DeadlineToDoListView: React.FC<AllTodoListViewProps> = (props) => {
  const todoService = useTodoService();
  const { filter } = useFilterContext<TodoFormTypes.Filter>();

  const filterFunc = (baseFilter: WintUtilsWebApi.Filter, key?: number) => {
    const deadlineTypes = filter?.deadlineTypes?.length ? filter.deadlineTypes : todoService.getDefaultDeadlineTypes();
    return todoService.reportFilter(baseFilter, key, {
      ...(filter ?? {}),
      deadlineTypes,
    });
  };

  return <ToDoListViewInner reloadKey={props.reloadKey} filter={filterFunc} />;
};

export default DeadlineToDoListView;
